import * as React from "react"
import * as styles from "./styles.module.scss"
import Document from "components/Document"
import ContactUs from "components/ContactUs"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import SideNav from "components/SideNav"
import Footer from "components/Footer"
import { brand } from "config/brand"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import SubNavbarAbout from "components/SubNavbarAbout"

export interface ContactUsPageProps {
  raw?: boolean
}

const ContactUsPage: React.FC<ContactUsPageProps> = ({ raw }) => {
  return (
    <Document
      title="Contact Us"
      description={`Get in touch with ${brand.name}.`}
      pageId="ContactUs"
      pageClass="LegalPage AboutUsPage"
    >
      <Navbar getStartedType={GetStartedType.ALWAYS} />
      <SubNavbarAbout />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.SubNavbar}>
        <main className={styles.contactUs}>
          <ContactUs />
        </main>
        {!raw && <Footer />}
      </PageWrapper>
    </Document>
  )
}

export default ContactUsPage
